import { useEffect } from 'react';
import { connect } from 'react-redux';

import useMeasure from 'src/hooks/useMeasure';
import { commonActions } from 'src/redux/commonRedux';
import { IAppState } from 'src/store';
import './styles.scss';

const ResponsiveContainer: React.FC<Props> = ({ isLoading, onToggleSidebar }) => {
  const {
    bind,
    bounds: { width },
  } = useMeasure();

  useEffect(() => {
    if (width >= 1024) {
      onToggleSidebar(false);
    } else {
      onToggleSidebar(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);

  return <div className="ctn-responsive" {...bind} />;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
});

const mapDispatchToProps = {
  onToggleSidebar: commonActions.setCollapseSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveContainer);
